import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 relative overflow-hidden" data-id="element-130">
      <div className="max-w-md sm:max-w-lg mx-auto text-center relative z-10" data-id="element-131">
        {/* Attention pill */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-brand-card border border-brand-danger/40 px-4 py-1.5 rounded-full mb-5" data-id="element-132">
          <span className="w-2 h-2 rounded-full bg-brand-danger animate-pulse" data-id="element-133" />
          <span className="text-[11px] sm:text-xs font-black tracking-wider text-brand-danger uppercase" data-id="element-134">
            DOCENTI DI LETTERE: SMETTETE DI SACRIFICARE LE VOSTRE SERATE ALLA
            PIANIFICAZIONE
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="text-[28px] sm:text-4xl font-black text-brand-cream leading-[1.1] mb-4" data-id="element-135">
          BASTA DOMENICHE PASSATE A{' '}
          <span className="text-brand-orange" data-id="element-136">PIANIFICARE.</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-base sm:text-lg text-gray-400 mb-6 leading-snug" data-id="element-137">
          Recupera la tua passione per l'insegnamento con il{' '}
          <span className="text-brand-cream font-bold" data-id="element-138">
            kit professionale di Lettere già pronto all'uso
          </span>
          . UDA, griglie di valutazione e materiali inclusivi allineati al MIM
          2026, a portata di click.
        </motion.p>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15
      }} className="mb-6" data-id="element-139">
          <a href="#pricing" className="block cursor-pointer" data-id="element-140">
            <img src="https://cdn.magicpatterns.com/uploads/aVHrhd3pNybszQwHRcKbHa/my-project-page-1_(2).png" alt="Sistema Integrato Italiano" className="w-full h-auto object-contain drop-shadow-2xl scale-110" data-id="element-141" />
          </a>
        </motion.div>

        {/* Star rating */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex items-center justify-center gap-2 mb-3" data-id="element-142">
          <div className="flex" data-id="element-143">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-brand-gold fill-current drop-shadow-[0_0_6px_rgba(251,191,36,0.6)]" data-id="element-144" />)}
          </div>
          <span className="text-sm font-bold text-brand-cream" data-id="element-145">
            4.9/5 (+500 Recensioni Verificate)
          </span>
        </motion.div>

        {/* Scarcity pill */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.25
      }} className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full mb-5" data-id="element-146">
          <span className="text-sm font-bold text-brand-orange" data-id="element-147">
            🔥 52 docenti hanno acquistato oggi
          </span>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-148">
          <CTAButton className="w-full" data-id="element-149">
            SÌ, VOGLIO RECUPERARE IL MIO TEMPO
          </CTAButton>
        </motion.div>

        {/* Trust line */}
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-5 text-xs text-gray-400 font-medium" data-id="element-150">
          <span data-id="element-151">⚡ Download Immediato</span>
          <span className="text-gray-600" data-id="element-152">•</span>
          <span data-id="element-153">🛡️ Garanzia 30 Giorni</span>
          <span className="text-gray-600" data-id="element-154">•</span>
          <span data-id="element-155">💳 Pagamento Unico</span>
        </div>

        {/* Country flags */}
        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-156">
          <div className="flex items-center justify-center gap-2" data-id="element-157">
            {[{
            code: 'it',
            name: 'Italia'
          }, {
            code: 'ch',
            name: 'Svizzera'
          }, {
            code: 'es',
            name: 'Spagna'
          }, {
            code: 'fr',
            name: 'Francia'
          }, {
            code: 'de',
            name: 'Germania'
          }].map(c => <div key={c.code} className="w-7 h-7 rounded-full overflow-hidden border border-white/20 shadow" title={c.name} data-id="element-158">
                <img src={`https://flagcdn.com/w80/${c.code}.png`} alt={c.name} className="w-full h-full object-cover" data-id="element-159" />
              </div>)}
          </div>
          <p className="text-[11px] text-gray-500 font-medium" data-id="element-160">
            +12.000 docenti in Italia ed Europa
          </p>
        </div>
      </div>
    </section>;
}